import React from "react";
import {
  useTest,
  useDispatchTestForm,
  useActionsTest,
} from "../../../../../context/inventory/TestFormProvider";
import Toggle from "react-toggle";
import Moment from "react-moment";
import "./versions.css";
import { FORMAT_DATETIME_MOMENT } from "../../../../../api/constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faCaretUp,
  faFilePen
} from "@fortawesome/free-solid-svg-icons";
import { types } from "../../../../../reducers/inventory/testReducer";
import Observations from "./Observations";
import Document from "./Document";
import Items from "./Items";
import { json } from "react-router-dom";

const Versions = () => {
  const state = useTest();
  const dispatchTestForm = useDispatchTestForm();
  const actions = useActionsTest();

  const { version, description, version_id, panelObservation } =
    state.test.test_version;
  const { up, watchDocuments } = panelObservation;
  const { version_list, reference } = state.test;
  const changeInputTest = (e) => {
    dispatchTestForm({
      type: types.CHANGE_INPUT_NEW_VERSION,
      payload: { name: e.target.name, value: e.target.value },
    });
  };
  return (
    <section className="section-list-versions">
      <div className="flex">
        <div className="flex1 flex-column">
          <div className="row">
            <div className="col-md-2 form-group">
              <label className="control-label">Versión</label>
              <input
                className="form-control"
                name="version"
                value={version}
                onChange={(e) => changeInputTest(e)}
                type="number"
              />
            </div>
            <div className="col-md-10 form-group">
              <label className="control-label">Descripción</label>
              <input
                name="description"
                value={description}
                onChange={(e) => changeInputTest(e)}
                className="form-control"
                type="text"
              />
            </div>
            <div
              className="flex justify-end"
              style={{ marginTop: "12px", marginBottom: "20px" }}
            >
              <div
                className="btn-default"
                onClick={() => actions.createVersion()}
              >
                <FontAwesomeIcon icon={faFilePen} /> &nbsp;Nueva
              </div>
            </div>
          </div>
          <table className="table table-default-app table-list-version">
            <thead>
              <tr>
                <th scope="col">Estado</th>
                <th scope="col">Referencia</th>
                <th scope="col">Descripción</th>
                <th scope="col">Fecha</th>
                <th scope="col">Responsable</th>
              </tr>
            </thead>
            <tbody>
              {version_list.versions.map((v) => {
                return (
                  <tr
                    style={{
                      backgroundColor:
                        version_id === v.id && "var(--line-selected)",
                    }}
                    key={v.id}
                  >
                    <td>
                      <Toggle
                        onClick={() =>
                          actions.updateFieldVersion(v.id, {
                            is_active: !v.is_active,
                          })
                        }
                        icons={false}
                        checked={v.is_active}
                      />{" "}
                      &nbsp; {v.is_active ? "Activa" : "Inactiva"}
                    </td>
                    <td>
                      <span
                        className="cursor-pointer"
                        onClick={() =>
                          dispatchTestForm({
                            type: types.CHANGE_INPUT_NEW_VERSION,
                            payload: { name: "version_id", value: v.id },
                          })
                        }
                      >
                        {reference}-{v.version}
                      </span>
                    </td>
                    <td 
                        onClick={() =>
                          dispatchTestForm({
                            type: types.CHANGE_INPUT_NEW_VERSION,
                            payload: { name: "version_id", value: v.id },
                          })
                        } className="cursor-pointer description-version-table" title={v.description}> {v.description}</td>
                    <td className="cursor-pointer"
                        onClick={() =>
                          dispatchTestForm({
                            type: types.CHANGE_INPUT_NEW_VERSION,
                            payload: { name: "version_id", value: v.id },
                          })
                        }>
                      {" "}
                      <Moment
                        date={v.created_at}
                        format={FORMAT_DATETIME_MOMENT}
                      />{" "}
                    </td>
                    <td className="cursor-pointer"
                        onClick={() =>
                          dispatchTestForm({
                            type: types.CHANGE_INPUT_NEW_VERSION,
                            payload: { name: "version_id", value: v.id },
                          })
                        }>{v.responsable && v.responsable.name} </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="line-versions h100"></div>
        {version_id && (
          <div className="flex1 flex container-version-documents">
            <Items />

            <div
              className={` ${
                up ? "fade-in-observation" : "fade-out-observation"
              } container-footer-observation-entry container-footer-observation-entry_test flex`}
            >
              <div className="w-100">
                <div className="flex container-tabs-entry">
                  <div
                    onClick={() =>
                      dispatchTestForm({
                        type: types.SET_PANEL_OBSERVATION,
                        payload: false,
                      })
                    }
                    className={` ${watchDocuments && "tab-inactive-entry"} `}
                  >
                    Observaciones
                  </div>
                  <div
                    onClick={() =>
                      dispatchTestForm({
                        type: types.SET_PANEL_OBSERVATION,
                        payload: true,
                      })
                    }
                    className={` ${!watchDocuments && "tab-inactive-entry"} `}
                  >
                    Archivos
                  </div>{" "}
                </div>

                <div
                  onClick={() =>
                    dispatchTestForm({ type: types.TOGGLE_PANEL_OBSERVATION })
                  }
                  className="button-up-footer-obsevation-entry"
                >
                  <FontAwesomeIcon
                    className="margin-auto blue"
                    icon={up ? faCaretDown : faCaretUp}
                  />{" "}
                </div>
                <div className="content-tab-observation-entry_test content-tab-observation-entry w-100">
                  {" "}
                  {!watchDocuments && up && <Observations />}
                  {watchDocuments && up && <Document />}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Versions;
